import type { ImageValue } from '@elfsight/configurator-contracts';
import type { Job } from '../../types';

const DEFAULT_COVER =
  'https://universe-static.elfsightcdn.com/app-static/job-board/images/cover-placeholder.jpg';

export const coverUrl = function (cover: ImageValue, jobs: Job[]) {
  return cover?.url ?? (jobs?.some((job) => job?.cover?.url) && DEFAULT_COVER);
};
